import React from "react";
import H2 from "../../shared/h2/component";
import PropTypes from "prop-types";
import Slider from "react-slick";
import styles from "./styles.css";
import HappyPurchaseCard from "../happy-purchase-card/component";
import One from "./images/one.png";
import Two from "./images/two.png";
import Three from "./images/three.png";
import Four from "./images/four.png";
import Five from "./images/five.png";
import halfStars from "./images/half-stars.svg";
import fullStars from "./images/stars.svg";
import { PAGE_SOURCE } from "../../../constants/app-constants";

const HappyPurchase = ({source, showTitle = true}) => {
    const settings = {
        slidesToShow: 2.6,
        slidesToScroll: 1,
        infinite: false,
        arrow: true,
        dots: true
    };
    const cdpSettings = {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        arrow: false,
        dots: false
    };
    const getSettings = () => {
        if (source === PAGE_SOURCE.CDP) {
            return cdpSettings;
        } else {
            return settings;
        }
    };
    const data = [
        {
            heading: "Mitchell's Perfect Match!",
            rating: "4.5",
            stars: halfStars,
            cardImage: One,
            content: "Excited and all smiles, Mitchell's new Holden Commodore SV6 arrived in Toowoomba from CARS24. The online ad was a perfect match, offering the ideal price, mileage, and condition he wanted. Ready to show off his beauty to workmates!"
        },
        {
            heading: "Cody and Kate's Early Weekend Surprise!",
            rating: "5.0",
            stars: fullStars,
            cardImage: Two,
            content: "Cody and Kate couldn't believe their luck when they received their new Ford Ranger four days ahead of schedule, thanks to the incredible team at CARS24 Australia. The seamless and efficient transaction made the entire process a breeze."
        },
        {
            heading: "Brayden got his first car!",
            rating: "4.5",
            stars: halfStars,
            cardImage: Three,
            content: "Brayden's online discovery of CARS24 left him thoroughly impressed with the exceptional experience. The top-notch service, user-friendly platform, and speedy process were a perfect fit. As a first-time car owner, the delivery of his stunning Ford Ranger to his door filled his heart with joy. He'll be back for future car needs."
        },
        {
            heading: "Mirko and Lil's Perfect Companion!",
            rating: "5.0",
            stars: fullStars,
            cardImage: Four,
            content: "Mirko and Lil's boundless excitement as their new Kia Sportage arrived in Zillmere. With a larger car for holidays, they chose CARS24 based on their daughter's positive experience with a Toyota Tarago from the company."
        },
        {
            heading: "Peter and his love for Audi!",
            rating: "5.0",
            stars: fullStars,
            cardImage: Five,
            content: "Petrus (Peter) was all smiles when he received his Audi A1 at his home in North Lakes. Already a devoted Audi enthusiast, With a rare gem featuring manual transmission and impressively low mileage, he knew he had found the perfect match"
        }
    ];

    const handleScroll = () => {};
    return (
        <div styleName={"styles.happyPurchaseWrap"}>
            {showTitle && <H2 text="Happy Purchases" />}
            <Slider {...getSettings()} afterChange={() => handleScroll()}>
                {data.map((item, index) => (
                    <HappyPurchaseCard key={index} cardImage={item.cardImage} heading={item.heading} rating={item.rating} stars={item.stars} content={item.content} />
                ))}
            </Slider>
        </div>
    );
};

HappyPurchase.propTypes = {
    source: PropTypes.string,
    showTitle: PropTypes.bool
};
export default HappyPurchase;
